export default __webpack_public_path__ + "static/media/7.e26ef9f9.jpg";